import { CSSProperties, Component } from 'react'
import { ProfileLink } from '../../../generic'
import { Button } from '@lmc/ui-kit'
import { Resident } from '@lmc/ts-common'

interface CompleteProps {
  fields: any
  formId: string
  residents: Resident[]
  onClose: () => void
  preferredPeopleNominative: string
}

export default class Complete extends Component<CompleteProps> {
  componentDidMount() {
    // @ts-ignore
    const { mixpanel } = this.props
    if (mixpanel) mixpanel.track(`CO_complete_emar_onboarding`)
  }

  renderResidents = () => {
    const { residents, onClose } = this.props
    return residents.map((resident) => (
      <div style={styles.linkContainer as CSSProperties} key={resident.id}>
        <ProfileLink
          onClick={() => onClose()}
          list="residents"
          altLocation="emar"
          id={resident.id}
          picture={resident.picture}
        />
        <div style={styles.residentName}>
          {resident.name.first} {resident.name.last}
        </div>
      </div>
    ))
  }

  render() {
    const { preferredPeopleNominative, onClose } = this.props
    const peoplePlural = preferredPeopleNominative.toLowerCase()
    const peopleSingular = peoplePlural.replace(/$^/, '')

    return (
      <div style={styles.container as CSSProperties}>
        <div style={styles.topText as CSSProperties}>
          <div>Amazing! Your eMAR module is all set up!</div>
          <div>
            Now you can start adding medication to {peoplePlural}. We recommend
            you start with your test {peopleSingular} first.
          </div>
        </div>
        <div style={styles.skipSection}>
          <div style={{ fontSize: '16px' }}>
            Go to {peoplePlural} medication page
          </div>
          <br />
          <Button variant="default" onClick={() => onClose()}>
            <div className={styles.skipButton as any}>
              <img
                alt=""
                src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/Skip.svg"
                style={{ marginRight: 5 }}
              />
              Skip for now
            </div>
          </Button>
        </div>
        <div style={styles.residentSection as CSSProperties}>
          {this.renderResidents()}
        </div>
        <Button variant="default" onClick={() => onClose()}>
          Back to home
        </Button>
      </div>
    )
  }
}

const styles = {
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: 960,
    height: '100%',
    padding: '16px',
    marginTop: 16,
  },
  topText: {
    marginBottom: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  bottomText: {
    marginTop: 32,
    fontSize: 12,
  },
  skipSection: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 32,
  },
  skipButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2,
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: 8,
    borderBottom: '1px solid #DDDDDD',
    width: '100%',
    fontWeight: 'bold',
    marginBottom: 3,
  },
  residentSection: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  residentName: {
    marginLeft: 16,
    marginBottom: 12,
  },
}
